import { ERROR_MESSAGES, FIELDS, IDuTypeError } from "../../../Interfaces/IDuTypeFormField";
import { IValidationRules } from "../../../Interfaces/IValidationRule";
import { getData } from "../../../Service-Utils/autoCompleteHelper";
import { IDuTypeFormValueType } from "../../../Types/duTypeFormProps";

export const IsNullEmptyUndefined = (value: any) => {
  if (typeof value === "string") {
    return value?.trim() === "";
  }

  return value === undefined || value === null;
}

const required = (
  value: any,
  formValues: any,
  field: any,
  ruleConfig?: any | undefined
) => {
  const isValid = !IsNullEmptyUndefined(value);
  return {
    valid: isValid,
    errorMessage: isValid ? "" : ERROR_MESSAGES.required,
  };
};

const decimal = (value: any, formValues: any, field: any) => {
  if (IsNullEmptyUndefined(value)) {
    return { valid: true, errorMessage: "" };
  }

  const isValid = RegExp("^[+-]?[0-9]\\d*(\\.\\d+)?$").test(value);
  return {
    valid: isValid,
    errorMessage: isValid ? "" : ERROR_MESSAGES.decimal,
  };
};

const integer = (value: any, formValues: any, field: any) => {
  if (IsNullEmptyUndefined(value)) {
    return { valid: true, errorMessage: "" };
  }

  const isValid = RegExp("^[+-]?[0-9]\\d*$").test(value);
  return {
    valid: isValid,
    errorMessage: isValid ? "" : ERROR_MESSAGES.integer(value),
  };
};

const alphanumeric = (value: any, formValues: any, field: any) => {
  if (IsNullEmptyUndefined(value)) {
    return { valid: true, errorMessage: "" };
  }

  const isValid = RegExp("^[a-zA-Z0-9 ]*$").test(value);
  return {
    valid: isValid,
    errorMessage: isValid ? "" : ERROR_MESSAGES.alphanumeric,
  };
};

const inputRange = (
  value: any,
  formValues: any,
  field: any,
  ruleConfig?: any
) => {
  if (IsNullEmptyUndefined(value)) {
    return { valid: true, errorMessage: "" };
  }

  let lowerLimit = ruleConfig?.lowerLimit;
  let upperLimit = ruleConfig?.upperLimit;
  value = value * 1;

  switch (ruleConfig?.comparision) {
    case "greater":
      {
        if (lowerLimit !== undefined) {
          if (value > lowerLimit) {
            return { valid: true, errorMessage: "" };
          }
          else {
            return {
              valid: false,
              errorMessage: ERROR_MESSAGES.inputRange(lowerLimit, undefined, "", ruleConfig.comparision),
            };
          }
        }
        break;
      }
    case "greaterOrEqual":
      {
        if (lowerLimit !== undefined) {
          if (value >= lowerLimit) {
            return { valid: true, errorMessage: "" };
          }
          else {
            return {
              valid: false,
              errorMessage: ERROR_MESSAGES.inputRange(lowerLimit, undefined, "", ruleConfig.comparision),
            };
          }
        }
        break;
      }
    default:
      {
        if (lowerLimit !== undefined && upperLimit !== undefined) {
          if (value >= lowerLimit && value <= upperLimit) {
            return { valid: true, errorMessage: "" };
          } else {
            return {
              valid: false,
              errorMessage: ERROR_MESSAGES.inputRange(lowerLimit, upperLimit, ""),
            };
          }
        }
      }

  }

  return { valid: true, errorMessage: "" };
};

const custom = (value: any, formValues: any, field: any, ruleConfig?: any, isLinkedAlready?: boolean) => {
  if (IsNullEmptyUndefined(value)) {
    return { valid: true, errorMessage: "" };
  }

  switch (field) {
    case FIELDS.minPickVolume.name: {
      if (IsNullEmptyUndefined(formValues.maxPickVolume)) {
        return { valid: true, errorMessage: "" };
      }

      if (value > formValues.maxPickVolume) {
        return {
          valid: false,
          errorMessage: "Min Pick Volume must be less than or equal to Max Pick Volume",
        };
      }
      break;
    }
    case FIELDS.maxPickVolume.name: {
      if (IsNullEmptyUndefined(formValues.minPickVolume)) {
        return { valid: true, errorMessage: "" };
      }
      if (value < formValues.minPickVolume) {
        return {
          valid: false,
          errorMessage: "Max Pick Volume must be greater than or equal to Min Pick Volume",
        };
      }
      break;
    }
    case FIELDS.mlpIndicator.name: {
      if (value === true) {
        if (IsNullEmptyUndefined(formValues.linkedContainers) || formValues.linkedContainers?.length < 1) {
          return {
            valid: false,
            errorMessage: ERROR_MESSAGES.mlpIndicator,
          };
        }
      }
      break;
    }
    case FIELDS.isLinkableContainer.name: {
      if (value === false && isLinkedAlready === true) {
        return {
          valid: false,
          errorMessage: ERROR_MESSAGES.isLinkable
        };
      }
      break;
    }
    case FIELDS.legacyContainerHasValue.name: {
      if (IsNullEmptyUndefined(formValues.legacyContainerDetails) || formValues.legacyContainerDetails?.length < 1) {
        return {
          valid: false,
          errorMessage: ERROR_MESSAGES.legacyContainerHasValue
        };
      }
      break;
    }
  }

  return {
    valid: true,
    errorMessage: "",
  };
};

/*Validations*/
/*Rules*/
const rules = {
  required,
  integer,
  decimal,
  alphanumeric,
  inputRange,
  custom
};


export const validateContainerType = async (field: string, value: any, formValues: any) => {
  let data = value.toLowerCase().trim()
  let response = await getData("dutypemaintenance/DuTypeMaintenances", `tolower(ContainerType) eq '${data}'`, true, 0, 1, data)
  let result = true;
  let errorMsg = "";
  if (response.length > 0) {
    result = false;
    errorMsg = `Container Type ${value} already exists`;
  }
  return { result, errorMsg };
}

export const validateContainerName = async (field: string, value: any, formValues: any) => {
  let data = value.toLowerCase().trim()
  let response = await getData("dutypemaintenance/DuTypeMaintenances", `tolower(ContainerName) eq '${data}'`, true, 0, 1, data)
  let result = true;
  let errorMsg = "";
  if (response.length > 0) {
    result = false;
    errorMsg = `Container Name ${value} already exists`;
  }
  return { result, errorMsg };
}

export const validateField = (field: string, value: any, formValues: any, isLinkedAlready: boolean) => {
  let result = true;
  const errors = { [field]: "" };
  Object.keys(FIELDS[field as keyof typeof FIELDS].rules).forEach(
    (rule) => {

      if (!result) {
        return;
      }

      const fieldResult = rules[rule as keyof typeof rules](
        value,
        formValues,
        field,
        (FIELDS[field as keyof typeof FIELDS]?.rules as IValidationRules)?.[rule as keyof typeof rules],
        isLinkedAlready
      );

      if (!fieldResult.valid) {
        result = false;
        errors[field] = fieldResult?.errorMessage;
      }
    }
  );

  return { result, errors };
};

// export const validateLegacyContainerData = (values: IDuTypeFormValueType) => {
//   var isContainerExistInLegacy = values.legacyContainers?.findIndex(x => x.mainContainerType === values.containerType
//     && x.customerType === values.customerType);
//   if (isContainerExistInLegacy !== -1) {
//     return { isValid:false, errors:`Container Type ${values.containerType} and CustomerType ${values.customerType} do not have any legacy container ` };
//   } else {
//     return {isValid:true,errors:null};
//   }
// }

export const validateForm = async (values: IDuTypeFormValueType, isEdit: boolean, isLinkedAlready: boolean) => {
  let result = true;
  const errors: IDuTypeError = {
    containerName: undefined,
    containerType: undefined,
    description: undefined,
    // legacyContainerName: undefined,
    // legacyContainerType: undefined,
    // legacyDescription: undefined,
    //customerType: undefined,
    fullLength: undefined,
    fullWidth: undefined,
    fullHeight: undefined,
    volume: undefined,
    weight: undefined,
    weightCap: undefined,
    minPickVolume: undefined,
    maxPickVolume: undefined,
    lpIndicator: undefined,
    mlpIndicator: undefined,
    muIndicator: undefined,
    isLinkableContainer: undefined,
    legacyContainerHasValue: undefined
  };

  Object.keys(FIELDS).forEach((field) => {
    const fieldResult = validateField(
      field,
      values[field as keyof typeof FIELDS],
      values,
      isLinkedAlready
    );

    if (!fieldResult.result) {
      result = false;
      errors[field as keyof typeof FIELDS] = fieldResult.errors[field];
    }

  });

  if (!isEdit) {
    await validateContainerName(FIELDS.containerName.name, values.containerName, values).then((x) => {
      if (!x.result) {
        result = false;
        errors["containerName"] = x.errorMsg
      }
    });

    await validateContainerType(FIELDS.containerType.name, values.containerType, values).then((x) => {
      if (!x.result) {
        result = false;
        errors["containerType"] = x.errorMsg
      }
    });
  }


  return { result, errors };
};